import React from 'react';
import Copy from '@nib-components/copy';
import Link from '@nib-components/link';
import {Margin} from 'styled-components-spacing';

export const getCallForHelpContent = (brandConfig, tealiumTrack) => {
  const clickHandler = () => {
    window.location.href = `tel:${brandConfig.contactPhoneNumber}`;
    tealiumTrack('phone_number_click', {brand: brandConfig.brandName, number: brandConfig.contactPhoneNumber});
  };

  return (
    <Margin top={5}>
      <Copy measure={false}>
        Still can’t log in? Give us a call on{' '}
        <Link component="button" onClick={clickHandler}>
          {brandConfig.contactPhoneText}
        </Link>{' '}
        and one of our friendly team members will be happy to help.
      </Copy>
    </Margin>
  );
};
